import { Component, Inject, OnInit, ElementRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatStepper } from '@angular/material';
import { CURRENT_EMPLOYER } from 'src/@core/services/app.service';
import { ConfirmSignatureComponent } from '../confirm-signature/confirm-signature.component';
import SignaturePad from 'signature_pad';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Router } from '@angular/router';
import { FileHandle } from "src/app/shared/directives/dragDrop.directive";
import { svgToPng, Text2Sign } from "../auto-generate-signatureFromName";
import fonts from '../auto-generate-signatureFromName/fonts.json';
import { PDFDocument } from 'pdf-lib'
import { EmployerUploadService } from 'src/@core/services/employer/employer-upload.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { EmployerService } from 'src/@core/services/employer/employer.service';
import { ChangeDetectorRef } from 'node_modules/@angular/core';

export class Input {
  name: string;
  type: string;
  top: number;
  left: number;
  width: number;
  height: number;
  value; any;
  page?: number;
}

@Component({
  selector: 'hour4u-admin-sign-contract',
  templateUrl: './sign-contract.component.html',
  styleUrls: ['./sign-contract.component.scss']
})
export class SignContractComponent implements OnInit {
  pageStatus: string = 'gstDetails';
  gstInNumber: string = null;
  showGSTCompanyDetails: boolean = false;

  profile: any = null;
  btnTitle: string = 'Next';

  @ViewChild("stepper", { static: false }) stepper: MatStepper;
  @ViewChild("drawableSignatureCanvas", { static: true }) drawableSignatureCanvas: ElementRef;
  @ViewChild("cameraCapturedImageCanvas", { static: true }) cameraCapturedImageCanvas: ElementRef;
  @ViewChild('cameraLivestream', { static: true }) cameraLivestream;

  signaturePad: SignaturePad;
  selectedSignatureOption: any = null;
  uploadedSignature: any = null;
  signaturePersonName: string = null;
  pdfSrc: string = 'assets/sample.pdf';
  showCaptureImg: boolean = false;
  signatureCapturedByCamera: boolean = false;

  files: FileHandle[] = [];
  videoElement: HTMLVideoElement;
  selectAutoGeneratedSignatureImg: any = null;
  selectedFileImage: any = null;
  signatureList: any[] = [];
  signatureNameUpdate = new Subject<string>();
  selectedSignature: any = null;
  selectedSignatureImg: any = null;
  panCardFileObj: any = null;
  gstCertificateFileObj: any = null;
  panCard: any = null;
  gstCertificate: any = null;
  panCardImg: any = null;
  gstCertificateImg: any = null;
  signatureFileObj: any = null;
  finalSelectedSignature: any = null;
  pdfDocBytes: any = null;
  signedDocumentKey: string = null;

  check: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<SignContractComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    public router: Router,
    private uploadService: EmployerUploadService,
    private notify: NotificationService,
    public http: HttpClient,
    public employerService: EmployerService,
    private cdRef: ChangeDetectorRef
  ) {
    // Update signature img on name change
    this.signatureNameUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          const text2sign = new Text2Sign();
          const text2sign1 = new Text2Sign();
          this.signatureList = [];

          text2sign.generateSignature(this.signaturePersonName, 50, { url: fonts.Satisfaction, name: 'Satisfaction' }, 'black');
          const svgData = text2sign.getSVGdata();
          svgToPng(svgData, (img) => {
            this.signatureList.push(img)
          })
          text2sign1.generateSignature(this.signaturePersonName, 50, { url: fonts.Autography, name: 'Autography' }, 'black');
          const svgData1 = text2sign1.getSVGdata();
          svgToPng(svgData1, (img) => {
            this.signatureList.push(img)
          })
        } else {
          this.signatureList = [];
        }
      });
  }
  ngOnInit() { }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  ngAfterViewInit() {
    this.profile = JSON.parse(localStorage.getItem(CURRENT_EMPLOYER));
    console.log(this.profile)
    if (this.profile) {
      this.gstInNumber = this.profile.gstNumber;
      this.panCardImg = this.profile.panCardS3Key;
      this.gstCertificateImg = this.profile.gstDocumentS3Key;
      this.finalSelectedSignature = this.profile.signatureS3Key;
      this.pageStatus = 'gstDetails';
      if (this.gstInNumber) {
        this.showGSTCompanyDetails = true;
      }
      this.redirectScreen();
      // this.btnTitle = 'Sign & Preview Document';
      // this.openSignaturePage();
      // this.btnTitle = 'Okay';
      // this.pageStatus = 'successPage';
    } else {
      this.notify.error('Please login with particular employer account!')
    }
  }

  // redirection of  screen set based on status
  redirectScreen() {
    console.log(this.profile)
    if (this.profile.onboardingStatus) {
      if (this.profile.onboardingStatus == "GST_DETAILS_UPLOADED") {
        this.goToDocumentUploadSection();
        this.btnTitle = 'Next';
        this.pageStatus = 'documentUpload';
        this.stepper.selectedIndex = 1;
        return;
      }
      if (this.profile.onboardingStatus == "GST_DOCUMENT_UPLOADED") {
        this.panCardImg = this.profile.panCardS3Key;
        this.gstCertificateImg = this.profile.gstDocumentS3Key;
        this.btnTitle = 'Next';
        this.stepper.selectedIndex = 1;
        this.pageStatus = 'signAgreement';
        this.btnTitle = 'View and sign the agreement';
        this.stepper.selectedIndex = 2;
        this.signAgreement();
        return;
      }
      if (this.profile.onboardingStatus == "SIGNATURE_UPLOADED") {
        this.stepper.selectedIndex = 1;
        this.stepper.selectedIndex = 2;
        this.selectedSignatureImg = this.profile.signatureS3Key;
        this.finalSelectedSignature = this.profile.signatureS3Key;
        this.pageStatus = 'previewSignAgreement';
        this.btnTitle = 'Submit';
        this.previewSignedAgreement();
        return;
      }
      if (this.profile.onboardingStatus == "CONTRACT_SIGNED") {
        this.pageStatus = 'successPage';
        this.btnTitle = 'Okay';
        return;
      }
    } else {
      this.signaturePersonName = this.profile.name;
      this.gstInNumber = this.profile.gstNumber;
      this.pageStatus = 'gstDetails';
      if (this.gstInNumber) {
        this.showGSTCompanyDetails = true;
      }
    }
  }

  // Fetch cmpany details from GSTIN number
  fetchCompanyData() {
    this.showGSTCompanyDetails = true;
  }

  // go to doc uploads section
  goToDocumentUploadSection() {
    this.pageStatus = 'documentUpload';
  }

  // Submit pancard and gst certificate img and redirect to agreement sign instruction page
  submitDocuments() {
    if (this.panCardFileObj && this.gstCertificateFileObj) {
      this.uploadPanCard();
    } else {
      if (this.panCardImg && this.gstCertificateImg) {
      } else {
        this.notify.showMessage("Please upload required documents!", 2000);
      }
    }
  }

  // Upload pan card
  uploadPanCard() {
    this.uploadService.uploadEmployerContractImages(this.panCardFileObj).subscribe(
      res => {
        if (res) {
          this.panCardImg = environment.image_url + res.key;
          this.uploadGSTCertificate();
        }
      }, error => {
        this.notify.showMessage("Error while uploading document!", 2000);
      }, () => { });
  }

  // Upload gst certificate
  uploadGSTCertificate() {
    if (this.gstCertificateFileObj) {
      this.uploadService.uploadEmployerContractImages(this.gstCertificateFileObj).subscribe(
        res => {
          if (res) {
            this.gstCertificateImg = environment.image_url + res.key;
            this.notify.showMessage("Pan Card and GST Certificate Uploaded Successfully!", 2000);
            this.saveSignDocumentDetails("GST_DOCUMENT_UPLOADED");
            // this.pageStatus = 'agreementSignIn';
            // this.btnTitle = 'Submit for verification';
            // this.stepper.selectedIndex = 2;
          }
        }, error => {
          this.notify.showMessage("Error while uploading image!", 2000);
        }, () => { });
    }
  }

  // go to sign agreement page
  signAgreement() {
    this.pageStatus = 'signAgreement';
    this.loadPDF();
  }

  // load pdf
  async loadPDF() {
    // @ts-ignore
    pdfjsLib.GlobalWorkerOptions.workerSrc = 'assets/pdf.worker.js';

    // @ts-ignore
    const loadingTask = pdfjsLib.getDocument({
      url: '../assets/sample2.pdf',
      cMapUrl: 'assets/cmaps/',
      cMapPacked: true,
      enableXfa: true,
    });

    const SEARCH_FOR = "";
    // @ts-ignore
    const eventBus = new pdfjsViewer.EventBus()

    // @ts-ignore
    const pdfLinkService = new pdfjsViewer.PDFLinkService({
      eventBus,
    });

    // @ts-ignore
    const pdfFindController = new pdfjsViewer.PDFFindController({
      eventBus,
      linkService: pdfLinkService,
    });

    // @ts-ignore
    const pdfScriptingManager = new pdfjsViewer.PDFScriptingManager({
      eventBus,
      sandboxBundleSrc: 'assets/pdf.sandbox.js',
    });

    (function () {
      loadingTask.promise.then(async (pdfDocument) => {
        const page = await pdfDocument.getPage(1)
        const annotationData = await page.getAnnotations()
        annotationData[0].fieldValue = "2nd"
        annotationData[1].fieldValue = "RANDOM DATA"
        // annotationData[2].fieldValue = "23"
        // annotationData[3].fieldValue = "Random ONE"
        // annotationData[4].fieldValue = employer.email

        const container = document.getElementById("viewerContainer");

        // @ts-ignore
        const pdfViewer = new pdfjsViewer.PDFViewer({
          container,
          eventBus,
          linkService: pdfLinkService,
          findController: pdfFindController,
          scriptingManager: pdfScriptingManager,
          toolbar: {
            numPages: {
              pageNumber: {
                type: "pageNumber",
                maxDigits: 4,
              },
            }
          }
        });
        pdfLinkService.setViewer(pdfViewer);
        pdfScriptingManager.setViewer(pdfViewer);

        eventBus.on("pagesinit", function () {
          // We can use pdfViewer now, e.g. let's change default scale.
          pdfViewer.currentScaleValue = "page-width";

          // We can try searching for things.
          if (SEARCH_FOR) {
            eventBus.dispatch("find", { type: "", query: SEARCH_FOR });
          }
        });
        // Document loaded, specifying document for the viewer and
        // the (optional) linkService.
        pdfViewer.setDocument(pdfDocument);

        pdfLinkService.setDocument(pdfDocument, null);
      })
    })();
  }

  // next & prev btn click of pdf
  // nextBtnClick() {
  //   this.currentPage += 1;
  //   this.currentPage =
  //     this.currentPage > this.totalPages ? 1 : this.currentPage;
  //   this.loadPDF();
  // }

  // prevBtnClick() {
  //   this.currentPage -= 1;
  //   this.currentPage =
  //     this.currentPage < 1 ? this.totalPages : this.currentPage;
  //   this.loadPDF();
  // }


  // open draw signatuire screen
  openSignaturePage() {
    this.clearSignature();
    this.pageStatus = 'signaturePage';
    this.selectSignatureOption('drawSignature');
    this.signaturePersonName = this.profile.name;
    this.signatureNameUpdate.next(this.signaturePersonName);
  }

  // selected signature capture option
  selectSignatureOption(option) {
    this.clearSignature();
    this.selectedSignatureOption = option;
    this.signaturePersonName = null;
    this.signaturePersonName = this.profile.name;
    this.signatureNameUpdate.next(this.signaturePersonName);
    if (option == 'drawSignature') {
      // if (this.drawableSignatureCanvas)
      this.signaturePad = new SignaturePad(this.drawableSignatureCanvas.nativeElement);
    }
  }

  // Clear all capture and uploaded doc field
  clearSignature() {
    if (this.signaturePad) {
      if (!this.signaturePad.isEmpty())
        this.signaturePad.clear();
    }
    this.showCaptureImg = false;
    this.selectAutoGeneratedSignatureImg = null;
    this.files = [];
    this.signatureCapturedByCamera = false;
    this.selectedFileImage = null;
    this.uploadedSignature = null;
  }

  // select auto generated img
  selectAutoGeneratedImg(signature) {
    this.clearSignature();
    this.selectAutoGeneratedSignatureImg = signature;
  }

  // selected files for pancard , gst and signature
  selectedFile(event, field) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (field == 'panCard') {
        this.panCardImg = reader.result;
        this.panCardFileObj = file;
      }
      if (field == 'gstCertificate') {
        this.gstCertificateImg = reader.result;
        this.gstCertificateFileObj = file;
      }
      if (field == 'signature') {
        this.selectedFileImage = reader.result;
        this.signatureFileObj = file;
      }
    };
  }

  // file drag&drop file obj get
  filesDropped(files: FileHandle[]): void {
    this.clearSignature();
    this.files = files;
  }

  // clicked img by camera
  captureImage() {
    this.showCaptureImg = true;
    this.videoElement = this.cameraLivestream.nativeElement;
    navigator.mediaDevices
      .getUserMedia({
        video: { facingMode: 'environment' },
      })
      .then(stream => {
        this.videoElement.srcObject = stream;
      });
  }

  // capture signature with camera
  takePicture() {
    const canvasElement = this.cameraCapturedImageCanvas.nativeElement;
    const context = canvasElement.getContext('2d');
    context.drawImage(this.videoElement, 0, 0, canvasElement.width, canvasElement.height);
    this.signatureCapturedByCamera = true;
  }

  // after adding signature click on next
  confirmSignature() {
    // const dialogRef = this.dialog.open(ConfirmSignatureComponent, {
    //   disableClose: true,
    //   panelClass: 'confirm-signarure-dialog',
    //   position: { bottom: '14%' }
    // });

    // dialogRef.afterClosed().subscribe(result => {
    //   if (result) {
    if (this.check) {
      this.uploadSignature();
      // this.pageStatus = 'previewSignAgreement';
      // this.btnTitle = 'Submit';
    } else {
      this.notify.showMessage("Please accept terms!", 2000);
    }
    // }
    // });
  }

  // convert Img to blob file
  b64toBlob(b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  // Upload signature
  uploadSignature() {
    this.selectedSignatureImg = null;
    let pad = `data:image/png;base64,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`;
    console.log(this.signaturePad)
    if (this.signaturePad.toDataURL()) {
      if (this.signaturePad.toDataURL() != pad) {
        this.selectedSignatureImg = this.b64toBlob(this.signaturePad.toDataURL().split('base64,')[1], `image/${this.signaturePad.toDataURL().split('base64,')[0].split('data:image/')[1].replace(';', '')}`);
      }
    }
    if (this.selectAutoGeneratedSignatureImg) {
      this.selectedSignatureImg = this.b64toBlob(this.selectAutoGeneratedSignatureImg.split('base64,')[1], `image/${this.selectAutoGeneratedSignatureImg.split('base64,')[0].split('data:image/')[1].replace(';', '')}`);
    }
    if (this.signatureFileObj) {
      this.selectedSignatureImg = this.signatureFileObj;
    }
    console.log(this.selectedSignatureImg)
    if (this.selectedSignatureImg) {
      this.uploadService.uploadSignatureImages(this.selectedSignatureImg).subscribe(
        res => {
          if (res) {
            this.clearSignature();
            this.finalSelectedSignature = environment.image_url + res.key;
            this.notify.showMessage("Signature Uploaded Successfully!", 2000);
            this.saveSignDocumentDetails("SIGNATURE_UPLOADED");
            // this.previewSignedAgreement();
          }
        }, error => {
          this.notify.showMessage("Error while uploading signature!", 2000);
        }, () => { });
    } else {
      this.notify.showMessage("Please do signature!", 2000);
    }
  }

  // preview signed agreement
  async previewSignedAgreement() {
    const employer = JSON.parse(localStorage.getItem(CURRENT_EMPLOYER));

    // ussing pdf-lib a diffrent library to fill the form fields
    const formPdfBytes = await fetch('assets/sample2.pdf').then(res => res.arrayBuffer());
    // const emblemImageBytes1 = await fetch('assets/Signature.png').then(res => res.arrayBuffer());
    console.log(this.selectedSignatureImg)
    if (this.selectedSignatureImg) {
      const emblemImageBytes1 = await this.getImageAsArrayBuffer(this.finalSelectedSignature);

      const pdfDocLIB = await PDFDocument.load(formPdfBytes);

      // @ts-ignore
      const data = await pdfDocLIB.getForm().getField('the Effective Date by and between')

      await pdfDocLIB.getForm().getButton('Signature-Image-1_af_image')
        .setImage(await pdfDocLIB.embedPng(emblemImageBytes1))
      this.pdfDocBytes = null;
      this.pdfDocBytes = await pdfDocLIB.saveAsBase64({ dataUri: true })
      // @ts-ignore
      pdfjsLib.GlobalWorkerOptions.workerSrc = 'assets/pdf.worker.js';

      // @ts-ignore
      const loadingTask = pdfjsLib.getDocument({
        url: this.pdfDocBytes,
        cMapUrl: 'assets/cmaps/',
        cMapPacked: true,
        enableXfa: true,
      });

      const SEARCH_FOR = "";
      // @ts-ignore
      const eventBus = new pdfjsViewer.EventBus()

      // @ts-ignore
      const pdfLinkService = new pdfjsViewer.PDFLinkService({
        eventBus,
      });

      // @ts-ignore
      const pdfFindController = new pdfjsViewer.PDFFindController({
        eventBus,
        linkService: pdfLinkService,
      });

      // @ts-ignore
      const pdfScriptingManager = new pdfjsViewer.PDFScriptingManager({
        eventBus,
        sandboxBundleSrc: 'assets/pdf.sandbox.js',
      });

      (function () {
        loadingTask.promise.then(async (pdfDocument) => {
          const page = await pdfDocument.getPage(1)
          const annotationData = await page.getAnnotations()
          annotationData[0].fieldValue = "2nd"
          annotationData[1].fieldValue = "RANDOM DATA"
          annotationData[2].fieldValue = "23"
          annotationData[3].fieldValue = "Random ONE"
          annotationData[4].fieldValue = employer.email

          const container = document.getElementById("viewerContainer1");

          // @ts-ignore
          const pdfViewer = new pdfjsViewer.PDFViewer({
            container,
            eventBus,
            linkService: pdfLinkService,
            findController: pdfFindController,
            scriptingManager: pdfScriptingManager,
            toolbar: {
              numPages: {
                pageNumber: {
                  type: "pageNumber",
                  maxDigits: 4,
                },
              }
            }
          });
          pdfLinkService.setViewer(pdfViewer);
          pdfScriptingManager.setViewer(pdfViewer);

          eventBus.on("pagesinit", function () {
            // We can use pdfViewer now, e.g. let's change default scale.
            pdfViewer.currentScaleValue = "page-width";

            // We can try searching for things.
            if (SEARCH_FOR) {
              eventBus.dispatch("find", { type: "", query: SEARCH_FOR });
            }
          });
          // Document loaded, specifying document for the viewer and
          // the (optional) linkService.
          pdfViewer.setDocument(pdfDocument);
          pdfLinkService.setDocument(pdfDocument, null);
        })
      })();
    }
  }

  // Convert image into array buffer
  async getImageAsArrayBuffer(imageUrl: string): Promise<ArrayBuffer> {
    try {
      const response = await fetch(imageUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const arrayBuffer = await response.arrayBuffer();
      return arrayBuffer;
    } catch (error) {
      console.error('Error fetching image:', error);
      throw error;
    }
  }

  // submit pdf
  submitPDF() {
    if (this.pdfDocBytes) {
      let pdfDocBytes = this.b64toBlob(this.pdfDocBytes.split('base64,')[1], `application/${this.pdfDocBytes.split('base64,')[0].split('data:application/')[1].replace(';', '')}`);
      this.uploadService.uploadEmployerContractPDF(this.profile.id, pdfDocBytes).subscribe(res => {
        this.signedDocumentKey = res.key;
        this.profile.contractDocKey = this.signedDocumentKey;
        localStorage.setItem(CURRENT_EMPLOYER, JSON.stringify(this.profile));
        this.profile = JSON.parse(localStorage.getItem(CURRENT_EMPLOYER));
        this.signedContractSubmit();
      })
    } else {
      this.notify.showMessage("Signature not found!", 2000);
    }
  }

  // signed contract submit
  signedContractSubmit() {
    let obj = {
      "employerId": this.profile.id,
      "s3Key": this.profile.contractDocKey,
      "panCardS3Key": this.profile.panCardS3Key,
      "gstDocumentS3Key": this.profile.gstDocumentS3Key,
      "signatureS3Key": this.profile.signatureS3Key
    }
    this.uploadService.uploadSignedContract(obj).subscribe(
      res => {
        if (res) {
          this.saveSignDocumentDetails("CONTRACT_SIGNED");
          // this.btnTitle = 'Okay';
          // this.pageStatus = 'successPage';
        } else {
          this.btnTitle = 'Okay';
          this.pageStatus = 'errorPage';
        }
      }, ((err) => {
        this.btnTitle = 'Okay';
        this.pageStatus = 'errorPage';
      }))
  }

  // Go to Next screen
  next(btnTitle) {
    if (this.stepper) {
      if (this.stepper.selectedIndex == 0) {
        this.saveSignDocumentDetails("GST_DETAILS_UPLOADED");
        // this.goToDocumentUploadSection();
        // this.btnTitle = 'Next';
        // this.stepper.selectedIndex = 1;
        return;
      }
      if (this.stepper.selectedIndex == 1) {
        this.submitDocuments();
        return;
      }
      if (this.stepper.selectedIndex == 2) {
        if (btnTitle == 'View and sign the agreement') {
          this.btnTitle = 'Sign & Preview Document';
          this.openSignaturePage();
        }
        if (btnTitle == 'Sign & Preview Document') {
          this.confirmSignature();
        }
        if (btnTitle == 'Submit') {
          this.submitPDF();
        }
      }
    } else {
      if (btnTitle == 'Okay') {
        this.okayClick();
      }
    }
  }

  // save sign documents details with individual steps
  saveSignDocumentDetails(status) {
    let obj = {
      "id": this.profile.id,
      "email": this.profile.email,
      "name": this.profile.name,
      "gstNumber": this.profile.gstNumber,
      "contactNo": this.profile.contactNo,
      "address": this.profile.address,
      "advanceAmountPercentage": this.profile.advanceAmountPercentage,
      "panCardS3Key": this.panCardImg, // if not null onboarding status= GST_DOCUMENT_UPLOADED
      "gstDocumentS3Key": this.gstCertificateImg,//if not null onboarding status= GST_DOCUMENT_UPLOADED
      "signatureS3Key": this.finalSelectedSignature,//if not null onboarding status= SIGNATURE_UPLOADED
      "onboardingStatus": status
    }
    console.log(obj)
    this.employerService.updateEmployer(this.profile.id, obj).subscribe(res => {
      console.log(res)
      if (res) {
        localStorage.setItem(CURRENT_EMPLOYER, JSON.stringify(res));
        this.profile = JSON.parse(localStorage.getItem(CURRENT_EMPLOYER));
        this.redirectScreen();
      }
    }, ((err) => {
      this.notify.showMessage("Error while updating employer details!", 2000);
    }))
  }

  // // Go to Back screen
  // goBack() {
  //   if (this.stepper) {
  //     if (this.stepper.selectedIndex == 1) {
  //       this.pageStatus = 'gstDetails';
  //       this.gstInNumber = this.profile.gstNumber;
  //       if (this.gstInNumber) {
  //         this.showGSTCompanyDetails = true;
  //       }
  //       this.signaturePersonName = this.profile.name;
  //       this.stepper.selectedIndex = 0;
  //       return;
  //     }
  //     if (this.stepper.selectedIndex == 2) {
  //       this.goToDocumentUploadSection();
  //       this.btnTitle = 'Next';
  //       this.stepper.selectedIndex = 1;
  //       return;
  //     }
  //   } else {
  //     if (this.btnTitle == "View and sign the agreement") {
  //       this.submitDocuments();
  //       this.btnTitle = 'Submit for verification';
  //       this.stepper.selectedIndex = 2;
  //       return;
  //     }
  //     if (this.btnTitle == 'Sign & Preview Document') {
  //       this.signAgreement();
  //       this.btnTitle = 'View and sign the agreement';
  //       return;
  //     }
  //     if (this.btnTitle == 'Submit') {
  //       this.confirmSignature();
  //       return;
  //     }
  //   }
  // }

  // accept terms and conditions for signature accept
  okayClick() {
    this.dialog.closeAll();
  }

  // reject terms and conditions for signature accept
  cancelClick() {
    this.pageStatus = 'signaturePage';
  }

}
